var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveAssets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4260_42763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6 16C32.6 7.16344 25.4365 0 16.6 0C7.76342 0 0.599976 7.16344 0.599976 16C0.599976 24.8366 7.76342 32 16.6 32C25.4365 32 32.6 24.8366 32.6 16Z",
    fill: "url(#paint0_linear_4260_42763)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.93335,
    y: 9.3335,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8456,
    y: 9.3335,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7579,
    y: 9.3335,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.93335,
    y: 14.2476,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.93335,
    y: 19.1562,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8455,
    y: 14.2476,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8455,
    y: 19.1562,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7579,
    y: 14.2476,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7579,
    y: 19.1562,
    width: 3.50877,
    height: 3.50877,
    rx: 1,
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4260_42763",
    x1: 16.6,
    y1: 0,
    x2: 16.6,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4260_42763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.599976)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAssets);
export default __webpack_public_path__ + "static/media/active_assets.a74f72ae34ac35bf35c7ba0240953b57.svg";
export { ForwardRef as ReactComponent };